export function formatDate(
  input: string | Date,
  skipSeconds: boolean = false,
  includeTimezone: boolean = false
): string {
  const amountToSlice = skipSeconds ? 16 : 19;
  const date = typeof input === "string" ? new Date(input) : input;
  const formatted = date
    .toISOString()
    .slice(0, amountToSlice)
    .replace("T", " ");

  if (includeTimezone) {
    return `${formatted} (UTC)`;
  }

  return formatted;
}

export function formatRelativeTime(dateString: string): string {
  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMinutes = Math.floor(diffMs / (1000 * 60));
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffDays >= 1) {
    return `${diffDays} Days`;
  } else if (diffHours >= 1) {
    return `${diffHours} Hour`;
  } else {
    return `${diffMinutes} min`;
  }
}
